import React from 'react';
import {Header, Main} from "../common/components";


function App() {
  return (
    <div className="bg-bg--primary max-w-5xl mx-auto relative">
      <Header />
      <Main/>
      <footer></footer>
    </div>
  );
}

export default App;
